import environment from '@/environment';

const getProfessionalIds = () => {
  const ids = environment.securityNotice?.professionalIds;

  return Array.isArray(ids) ? ids : [];
};

export const securityNoticeEmail = () => environment.securityNotice?.dataProtectionEmail || 'rgpd@docline.es';

/**
 * El aviso solo se muestra a los profesionales cuyo professional_docline_api_id
 * esté listado en la configuración de entorno (deploy/environments/*.json).
 */
export default authUser => {
  if (!environment.securityNotice?.enabled) {
    return false;
  }

  const professionalId = authUser?.user?.professional_docline_api_id;

  return !!professionalId && getProfessionalIds().includes(professionalId);
};
